import { assignRef } from './assignRef';
import { createCallbackRef } from './createRef';
export function transformRef(ref, transformer) {
    return createCallbackRef(function (value) { return assignRef(ref, transformer(value)); });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-callback-ref/dist/es2015/transformRef.js
// module id = 1186
// module chunks = 0